export { createTranslationFile } from '@vocab/core/translation-file';
import { getParsedICUMessages } from '@vocab/core/icu-handler';

const createLanguage = loadImport => {
  let promiseValue;
  let resolvedValue;
  return {
    getValue: locale => {
      if (!resolvedValue) {
        return undefined;
      }
      return getParsedICUMessages(resolvedValue, locale);
    },
    load: () => {
      if (!promiseValue) {
        promiseValue = loadImport();
        promiseValue.then(value => {
          resolvedValue = value.default;
        });
      }
      return promiseValue;
    }
  };
};

export { createLanguage };
